//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Weld.js";
SPLM.Weld.OutputType = Object.freeze({
    "Associative" : "Associative", "Fixed" : "Fixed"});

SPLM.Weld.WeldArcMethod = Object.freeze({
    "Continuous" : "Continuous", "Skip" : "Skip"});

SPLM.Weld.WeldPrepareEdges = Object.freeze({
    "None" : "None", "EntireEdge" : "EntireEdge", "WeldLimits" : "WeldLimits", "Complex" : "Complex"});

SPLM.Weld.WeldTaperMethod = Object.freeze({
    "FromEndFace" : "FromEndFace", "FromSideFace" : "FromSideFace"});

SPLM.Weld.WeldPointMethod = Object.freeze({
    "Multiple" : "Multiple", "Single" : "Single", "Mirror" : "Mirror", "Translate" : "Translate", "FromPoints" : "FromPoints"});

SPLM.Weld.WeldPointReferenceSheetType = Object.freeze({
    "Overlap" : "Overlap", "Top" : "Top", "None" : "None"});

SPLM.Weld.WeldPointLocation = Object.freeze({
    "AlongGuideCurve" : "AlongGuideCurve", "AlongGuideEdge" : "AlongGuideEdge", "AlongCenterLine" : "AlongCenterLine", "SectionPlane" : "SectionPlane"});

SPLM.Weld.WeldPointExtendMethod = Object.freeze({
    "None" : "None", "Boundary" : "Boundary"});

SPLM.Weld.WeldPointSpacingMethod = Object.freeze({
    "Distance" : "Distance", "NumPoints" : "NumPoints"});

SPLM.Weld.WeldPointDirection = Object.freeze({
    "StartToEnd" : "StartToEnd", "EndToStart" : "EndToStart"});

SPLM.Weld.WeldGrooveShape = Object.freeze({
    "SquareButt" : "SquareButt", "VGroove" : "VGroove", "Bevel" : "Bevel", "UGroove" : "UGroove", "JGroove" : "JGroove", "FlaredV" : "FlaredV", "FlaredBevel" : "FlaredBevel", "FillinFlaredV" : "FillinFlaredV", "FillinFlaredBevel" : "FillinFlaredBevel"});

SPLM.Weld.WeldGrooveType = Object.freeze({
    "EdgesNotPrepared" : "EdgesNotPrepared", "EdgesPrepared" : "EdgesPrepared"});

SPLM.Weld.WeldGrooveExtension = Object.freeze({
    "Tangent" : "Tangent", "Project" : "Project", "ReverseProject" : "ReverseProject"});

SPLM.Weld.WeldContourShape = Object.freeze({
    "None" : "None", "Convex" : "Convex", "Flush" : "Flush", "Concave" : "Concave"});

SPLM.Weld.WeldRootUpdate = Object.freeze({
    "Automatic" : "Automatic", "None" : "None"});

SPLM.Weld.WeldFeatureOutput = Object.freeze({
    "Curves" : "Curves", "Solid" : "Solid", "Both" : "Both"});

SPLM.Weld.WeldCustom = Object.freeze({
    "SolidNone" : "SolidNone", "SolidSphere" : "SolidSphere", "SolidCylinder" : "SolidCylinder", "SolidCone" : "SolidCone", "SolidDefault" : "SolidDefault"});

SPLM.Weld.WeldProjectionMethod = Object.freeze({
    "None" : "None", "FaceNormal" : "FaceNormal", "AlongVector" : "AlongVector"});

SPLM.Weld.WeldSpacingCalcMethod = Object.freeze({
    "Arclength" : "Arclength", "ParallelXPlane" : "ParallelXPlane", "ParallelYPlane" : "ParallelYPlane", "ParallelZPlane" : "ParallelZPlane", "MiddleOfCurve" : "MiddleOfCurve", "NormalToBody" : "NormalToBody"});

SPLM.Weld.WeldFeatureSetType = Object.freeze({
    "FilletWeld" : "FilletWeld", "GrooveWeld" : "GrooveWeld", "ResistanceSpot" : "ResistanceSpot", "ArcSpot" : "ArcSpot", "Clinch" : "Clinch", "Dollop" : "Dollop", "WeldNut" : "WeldNut", "WeldStud" : "WeldStud", "Custom1Point" : "Custom1Point", "Custom2Point" : "Custom2Point", "Custom3Point" : "Custom3Point", "Custom4Point" : "Custom4Point", "Custom5Point" : "Custom5Point", "BiwDatumSurface" : "BiwDatumSurface", "BiwDatumPin" : "BiwDatumPin", "BiwDatumCustomer1" : "BiwDatumCustomer1", "BiwDatumCustomer2" : "BiwDatumCustomer2", "BiwDatumCustomer3" : "BiwDatumCustomer3", "BiwMeasurementSurface" : "BiwMeasurementSurface", "BiwMeasurementHole" : "BiwMeasurementHole", "BiwMeasurementSlot" : "BiwMeasurementSlot", "BiwMeasurementStud" : "BiwMeasurementStud", "BiwMeasurementTrim" : "BiwMeasurementTrim", "BiwMeasurementHem" : "BiwMeasurementHem", "BiwMeasurementCustomer1" : "BiwMeasurementCustomer1", "BiwMeasurementCustomer2" : "BiwMeasurementCustomer2", "BiwMeasurementCustomer3" : "BiwMeasurementCustomer3"});

SPLM.Weld.WeldAdvisorCustomerDefault = Object.freeze({
    "ResistanceSpot" : "ResistanceSpot", "ArcSpot" : "ArcSpot", "Clinch" : "Clinch", "Dollop" : "Dollop", "WeldNut" : "WeldNut", "WeldStud" : "WeldStud", "Custom1Point" : "Custom1Point", "Custom2Point" : "Custom2Point", "Custom3Point" : "Custom3Point", "Custom4Point" : "Custom4Point", "Custom5Point" : "Custom5Point", "Datum" : "Datum", "Measurement" : "Measurement", "Num" : "Num"});

SPLM.Weld.WeldGroupIdColor = Object.freeze({
    "None" : "None", "First" : "First", "Second" : "Second", "Third" : "Third", "Fourth" : "Fourth", "Fifth" : "Fifth", "Sixth" : "Sixth", "Seventh" : "Seventh", "Eighth" : "Eighth", "Ninth" : "Ninth", "Tenth" : "Tenth", "Eleventh" : "Eleventh", "Twelfth" : "Twelfth", "Thirteenth" : "Thirteenth", "Fourteenth" : "Fourteenth"});

SPLM.Weld.WeldDatumControlDirection = Object.freeze({
    "Invalid" : "Invalid", "X" : "X", "Y" : "Y", "Z" : "Z"});

SPLM.Weld.WeldMeasurementSizeMethod = Object.freeze({
    "Invalid" : "Invalid", "Auto" : "Auto", "Manual" : "Manual"});

SPLM.Weld.WeldOverlapStatus = Object.freeze({
    "Invalid" : "Invalid", "Creation" : "Creation", "NonCreation" : "NonCreation"});

SPLM.Weld.WeldFacesetIndex = Object.freeze({
    "First" : "First", "Second" : "Second", "Third" : "Third", "Forth" : "Forth"});

SPLM.Weld.WeldParasetLocation = Object.freeze({
    "Length" : "Length", "Percent" : "Percent", "ThroughPoint" : "ThroughPoint"});

SPLM.Weld.WeldAttribType = Object.freeze({
    "Integer" : "Integer", "Real" : "Real", "Null" : "Null", "String" : "String"});

SPLM.Weld.WeldSelectionType = Object.freeze({
    "General" : "General", "Surface" : "Surface", "Curve" : "Curve"});

SPLM.Weld.WeldCreationDirection = Object.freeze({
    "Default" : "Default", "Opposite" : "Opposite"});

SPLM.Weld.WeldAdvisorCheckerType = Object.freeze({
    "CoincidentPoint" : "CoincidentPoint", "MinimumPointDistance" : "MinimumPointDistance", "MinimumEdgeDistance" : "MinimumEdgeDistance", "StackUpGap" : "StackUpGap", "FacePlanarity" : "FacePlanarity", "FaceParallelism" : "FaceParallelism", "PointFaceDistance" : "PointFaceDistance", "CsysFaceNormalAngle" : "CsysFaceNormalAngle", "MetalStackUp" : "MetalStackUp", "MetalMinimumPointDatumDistance" : "MetalMinimumPointDatumDistance", "MetalMinimumPointMeasurementDistance" : "MetalMinimumPointMeasurementDistance", "SpacingPerPanelCombination" : "SpacingPerPanelCombination", "WeldFlange" : "WeldFlange", "Bead" : "Bead", "Number" : "Number"});

export default SPLM;